import { render } from "./DashboardShipping.vue?vue&type=template&id=691280e5&scoped=true"
import script from "./DashboardShipping.vue?vue&type=script&lang=js"
export * from "./DashboardShipping.vue?vue&type=script&lang=js"

import "./DashboardShipping.vue?vue&type=style&index=0&id=691280e5&scoped=true&lang=css"
import "./DashboardShipping.vue?vue&type=style&index=1&id=691280e5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691280e5"]])

export default __exports__